import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { AlertService } from 'src/app/providers/alert.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { CustomConfirmDialogComponent } from '../custom-confirm-dialog/custom-confirm-dialog.component';

@Component({
  selector: 'sm-view-media-gallery',
  templateUrl: './view-media-gallery.component.html',
  styleUrls: ['./view-media-gallery.component.scss']
})
export class ViewMediaGalleryComponent implements OnInit {


  public serviceListData: any = []
  // isDiscount!: boolean;
  // isShop: boolean = false
  // isHome: boolean = false
  // isPercent!: boolean
  // isAmount!: boolean
  // isHomeSpecific: Boolean = false;
  // isShopSpecific: Boolean = false;
  // entityHash: string = '';
  // hideRequiredControl = new FormControl(false);
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private loaderservice: LoaderServiceService,
    private _alertService: AlertService,
    // private sharedService: SharedService,
    public dialog: MatDialogRef<ViewMediaGalleryComponent>,
    private _matdialogref: MatDialog
  ) {}
  removeAsset() {
    this.serviceListData.imgUrl = '';
    this.assetList = [];
  }
  assetsData:any= []
  ngOnInit(): void {
    // console.log(this.isDiscount);
    // console.log(this.isPercent);


    // console.log(this.parentData.data);
    // this.route.queryParams.subscribe(data => {
    //   console.log(data.entityHash);
    //   this.entityHash = data.entityHash


    // })
    let data: any = []
    console.log(this.parentData.data);
    console.log(this.parentData);
    this.assetsData = []
    if(this.parentData.data.length > 0){
      const imageExtensions = /\.(jpe?g|png|gif|bmp|svg)$/i;
      const videoExtensions = /\.(mp4|avi|mov|mkv)$/i;

      this.parentData.data.forEach((element:any) => {
        if (element.asset_type == 1) {
          element.mediaType = 'image'
        } else if (element.asset_type == 2) {
          element.mediaType = 'video'
        } else {
          element.mediaType = 'unknown'
        }
        this.assetsData.push(element)
      });
    }

    Object.assign(data, this.parentData.data);
    console.log(data);
    if (data.hash_id) {
      this.assetList.push({
        assetName: data?.imgUrl
          .split('/')
          .pop()
          .substring(data.imgUrl.split('/').pop().lastIndexOf('_') + 1),
        url: data?.imgUrl,
      });
      this.serviceListData = data;
      this.editMode = true;
    }
  
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.RESULT_API_SET_MEDIA_AS_DEFAULT) {
        if (res.result) { 
          this.loaderservice.showLoader = false
          this._alertService.onOpenSnackbar("Media set as default successfully.");
          this._apiService.getBasicEntityList()
          this.parentData.ref.closeAll();
        }
       
      }
      if (res.responseType === SM_CONSTANTS.RESULT_API_DELETE_UPLOADED_MEDIA) {
        if (res.result) { 
          // this.loaderservice.showLoader = false
          this._alertService.onOpenSnackbar("Media deleted successfully.");
          this._apiService.getBasicEntityList()
          this._apiService.getEntityDetails(this.parentData.entityHash)
          this.parentData.ref.closeAll();
        }
       
      }
    });
  }
  

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    // console.log('Data', this.serviceListData);

    console.log(this.editMode);
    if (!this.editMode) {
      // this.serviceListData['hash_id'] = undefined;
    }

    
    if(this.serviceListData.home_rate == null || this.serviceListData.home_rate == '-' ){
      this.serviceListData.home_rate = 0
    }
    if(this.serviceListData.shop_rate == null || this.serviceListData.shop_rate == '-'){
      this.serviceListData.shop_rate = 0
    }



    Object.keys(this.serviceListData).forEach(key => {
      if ((this.serviceListData as any)[key] === null) {
        delete (this.serviceListData as any)[key];
      }
    });

 let bodydata = {
  serviceTypeInfo: this.serviceListData
 }
    console.log('updated data', bodydata);
    // this._apiService.addServiceTemplate(bodydata)
    this.dialog.close();
      setTimeout(() => {
        // this.sharedService.sendClickEvent();
      }, 2000);
    // this._apiService.updateBuisnessPromotion({
    //   promotionInfo: this.serviceListData,
    // });
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    // this._apiService.uploadAssets(formData, 1);
  }

  

  setDefaultImage(item:any){
    
    let data = {
      "entity_hash": this.parentData.entityHash, 
      "asset_hash": item.hash_id
    }
    console.log(data);
    this.loaderservice.showLoader = true
    this._apiService.setMediaAsDefault(data)  
  }

  deleteImage(item:any){
    const dialogRef = this._matdialogref.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to delete this media?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let obj = {
              "entityHash": this.parentData.entityHash, 
              "assetHash": item.hash_id
        }
        this.loaderservice.showLoader = true
        this._apiService.deleteUploadedMedia(obj)

      }
    })
    // if(this.assetsData.length == 1){
    //   console.log("last");
      
    //   let data = {
    //     entityInfo : {
    //       entityStatus: "1",
    //       hashId: this.parentData.entityHash,
    //       assetInfo: [
    //         {
    //           hash_id: item.hash_id,
    //           isDelete: 1
    //         }
    //       ],
    //       assetType: this.parentData.asset_type ,
    //       imgUrl: "null",
    //       thumbImgUrl: "null",
    //       isMediaOnly: 1
    //     }
    //   }
    //   console.log(data);
      
    //   this._apiService.updateEntityInfo(data)
    // }
    // else{
    //   let data = {
    //     entityInfo : {
    //       entityStatus: "1",
    //       hashId: this.parentData.entityHash,
    //       assetInfo: [
    //         {
    //           hash_id: item.hash_id,
    //           isDelete: 1
    //         }
    //       ],
    //       assetType: this.parentData.asset_type,
    //       isMediaOnly: 1
    //     }
    //   }
    //   console.log(data);
      
    //   this._apiService.updateEntityInfo(data)
    // }
    
  }

}
